import React from "react";
import { Box, Typography } from "@mui/material";

const EMOJIS = [
  "🔥",
  "✨",
  "🎉",
  "🛍",
  "💚",
  "⏰",
  "📦",
  "🎁",
  "👋",
  "☀️",
  "🏷",
  "💫",
  "🚚",
  "⚡️",
  "😍",
  "🙌",
];

export interface EmojiPickerPanelProps {
  onEmojiClick: (emoji: string) => void;
}

/** Plain @mui/material primitives only — see OsToggle for why. */
function EmojiPickerPanel(props: EmojiPickerPanelProps) {
  const { onEmojiClick } = props;

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        padding: "12px",
        marginBottom: "12px",
      })}
    >
      <Typography variant="caption" color="text.secondary">
        Emoji switch the message to Unicode — 70 characters per segment instead
        of 160.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(8, 1fr)",
          gap: "4px",
          marginTop: "8px",
        }}
      >
        {EMOJIS.map((emoji) => (
          <Box
            key={emoji}
            component="button"
            type="button"
            onClick={() => onEmojiClick(emoji)}
            aria-label={`Insert ${emoji}`}
            sx={(theme) => ({
              border: "none",
              background: "transparent",
              fontSize: 20,
              lineHeight: "32px",
              height: 32,
              cursor: "pointer",
              borderRadius: 1,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
              },
            })}
          >
            {emoji}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default EmojiPickerPanel;
